import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-150">
      <div className="max-w-4xl mx-auto text-center" data-id="element-151">
        {/* Logo */}
        <div className="text-[#00B4D8] text-3xl font-black tracking-widest mb-8" data-id="element-152">
          🇫🇷 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-153">
          El próximo domingo podés seguir buscando material en Google.
        </h2>
        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-10" data-id="element-154">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a2d] border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-4 max-w-2xl mx-auto text-left" data-id="element-155">
          <div className="p-4 bg-[#000d1a] border-b border-[#00B4D8]/30 text-center font-bold text-white" data-id="element-156">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-157">
            <div className="p-4 text-gray-400 text-sm" data-id="element-158">
              💸 3 horas de planificación × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-159">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-160">
            <div className="p-4 text-gray-400 text-sm" data-id="element-161">
              💸 Evaluaciones sin solucionario × 30 alumnos × 3 trimestres
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-162">
              sábados perdidos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-163">
            <div className="p-4 text-gray-400 text-sm" data-id="element-164">
              💸 Grupos sin diferenciación
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-165">
              alumnos que se pierden y no vuelven al francés
            </div>
          </div>
        </div>

        <p className="text-white text-lg sm:text-xl font-bold max-w-2xl mx-auto mb-12" data-id="element-166">
          Eso no es "ahorrar" $19.990. Es pagar con tu tiempo, tu energía y tu
          vida docente.
        </p>

        {/* Countdown */}
        <div className="mb-4" data-id="element-167">
          <p className="text-white font-bold mb-4" data-id="element-168">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-169" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-170">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-171">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-172">
          <div className="bg-[#0a0a0a] border border-[#00B4D8]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-173">
            <div className="text-2xl mb-2" data-id="element-174">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-175">MEGAPACK FRANCÉS</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-176">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-177">
              <p className="text-[#00B4D8] text-2xl font-black mb-4" data-id="element-178">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48159765070080:1" className="btn-green-pulse block bg-[#00B4D8] text-black font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm" data-id="element-179">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,180,216,0.2)] flex flex-col" data-id="element-180">
            <div className="text-2xl mb-2" data-id="element-181">🏆</div>
            <h3 className="text-[#00B4D8] font-black mb-1" data-id="element-182">
              MEGAPACK + ADAPTACIONES ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-183">
              6 Tomos + 6 Bonos + Kit Adaptaciones al Aula Pro
            </p>
            <div className="mt-auto" data-id="element-184">
              <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-185">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48159768019200:1" className="btn-green-pulse block bg-[#00B4D8] text-black font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm" data-id="element-186">
                → QUIERO EL MEGAPACK + ADAPTACIONES
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-187">
          <span data-id="element-188">🔒 Pago 100% seguro</span>
          <span data-id="element-189">⚡ Acceso en 5 minutos</span>
          <span data-id="element-190">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-191">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}